import { useEffect, useState } from "react";
import api from "@/lib/api";

const timeLeft = (activeUntil, now) => {
  const remaining = Math.max(0, new Date(activeUntil).getTime() - now);
  const days = Math.floor(remaining / 86400000);
  const hours = Math.floor((remaining % 86400000) / 3600000);
  return `${days}d ${hours}h remaining`;
};

export function OreRushEventNotice({ testId }) {
  const [event, setEvent] = useState(null);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    let mounted = true;
    const load = () => api.get("/mining/ore-rush-event").then((response) => mounted && setEvent(response.data)).catch(() => mounted && setEvent(null));
    load();
    const refresh = setInterval(load, 30000);
    const clock = setInterval(() => setNow(Date.now()), 60000);
    return () => { mounted = false; clearInterval(refresh); clearInterval(clock); };
  }, []);
  if (!event?.active) return null;
  return <section data-testid={testId} className="mb-6 border border-amber-500/60 bg-amber-950/25 px-5 py-4"><div className="flex flex-wrap items-center justify-between gap-3"><div><div className="text-xs uppercase tracking-[0.2em] text-amber-300">Ore Rush Event Active</div><p className="mt-1 text-sm text-zinc-100"><span className="font-semibold text-amber-200">3× discovery chance</span> and <span className="font-semibold text-amber-200">2× raw ore</span> from online expeditions and offline auto-mining.</p></div><span data-testid={`${testId}-countdown`} className="text-xs tabular-nums text-amber-200">{timeLeft(event.active_until, now)}</span></div></section>;
}